/* labelMapping.ts */

/* Constants */
import { TreatmentLabels } from "src/shared/constants/labels/TreatmentLabels";
import { ResponseTableStrings } from "src/shared/constants/table/ResponseTable";

/* Utils */
import { capitalizeCamelCaseFirstLetter } from "src/utils/helper/string-transformation";

/**
 * Map treatment keys to their corresponding labels.
 * The mapping is required to show the labels in their
 * correct format.
 */
export const treatmentTableLabelMapping: Record<
  string,
  string
> = {
  timeline: TreatmentLabels.TIMELINE,

  // Treatments
  araC: TreatmentLabels.ARA_C,
  cyclophosphamideMonotherapy:
    TreatmentLabels.CYCLOPHOSPHAMIDE_MONOTHERAPY,
  notReached: TreatmentLabels.NOT_REACHED,
  ongoing: TreatmentLabels.ONGOING,
  rBenda: TreatmentLabels.R_BENDA,
  rChop: TreatmentLabels.R_CHOP,
  rMiniChop: TreatmentLabels.R_MINI_CHOP,
  rMtx: TreatmentLabels.R_MTX,
  rPolaChp: TreatmentLabels.R_POLA_CHP,
  venetoclaxMonotherapy:
    TreatmentLabels.VENETOCLAX_MONOTHERAPY,
  acalabrutinibMonotherapy:
    TreatmentLabels.ACALABRUTINIB_MONOTHERAPY,
  bendamustineAndObinutuzumab:
    TreatmentLabels.BENDAMUSTINE_AND_OBINUTUZUMAB,
  bendamustineMonotherapy:
    TreatmentLabels.BENDAMUSTINE_MONOTHERAPY,
  chlorambucilAndObinutuzumab:
    TreatmentLabels.CHLORAMBULIC_AND_OBINUTUZMAB,
  chlorambucilMonotherapy:
    TreatmentLabels.CHLORAMBULIC_MONOTHERAPY,
  deceased: TreatmentLabels.DECEASED,
  fcr: TreatmentLabels.FCR,
  fludarabineAndRituximab:
    TreatmentLabels.FLUDARABINE_AND_RITUXIMAB,
  ibrutinibAndVenetoclax:
    TreatmentLabels.IBRUTINIB_AND_VENETOCLAX,
  ibrutinibMonotherapy:
    TreatmentLabels.IBRUTINIB_MONOTHERAPY,
  idelalisibAndRituximab:
    TreatmentLabels.IDELALISIB_AND_RITUXIMAB,
  idelalisibMonotherapy:
    TreatmentLabels.IDELAISIB_MONOTHERAPY,
  obinutuzumabMonotherapy:
    TreatmentLabels.OBINUTUZUMAB_MONOTHERAPY,
  rituximabMono: TreatmentLabels.RITUXIMAB_MONOTHERAPY,
  venetoclaxAndObinutuzumab:
    TreatmentLabels.VENETOCLAX_AND_OBINUTUZUMAB,
  zanubrutinibMonotherapy:
    TreatmentLabels.ZANUBRUTINIB_MONOTHERAPY,

  // Medications
  bortezomibIntravenous: TreatmentLabels.BORTEZOMIB,
  adalimumabMilligram: TreatmentLabels.ADALIMUMAB,
  azathioprineMilligram: TreatmentLabels.AZATHIOPRINE,
  budesonideMilligram: TreatmentLabels.BUDESONIDE,
  cortisoneMilligram: TreatmentLabels.CORTISONE,
  golimumabMilligram: TreatmentLabels.GOLIMUMAB,
  infliximabMilligram: TreatmentLabels.INFLIXIMAB,
  mesalamineMilligram: TreatmentLabels.MESALAMINE,
  prednisoloneMilligram: TreatmentLabels.PREDNISOLONE,
  ustekinumabMilligram: TreatmentLabels.USTEKINUMAB,
  vedolizumabMilligram: TreatmentLabels.VEDOLIZUMAB,
};

export const responseTableLabelMapping: Record<
  string,
  string
> = {
  overallResponseRateOrr:
    ResponseTableStrings.OVERALL_RESPONSE_RATE,
  completeResponse: ResponseTableStrings.COMPLETE_RESPONSE,
  partialResponse: ResponseTableStrings.PARTIAL_RESPONSE,
  progressiveDisease:
    ResponseTableStrings.PROGRESSIVE_DISEASE,
  stableDisease: ResponseTableStrings.STABLE_DISEASE,
  unknown: ResponseTableStrings.UNKNOWN,
  ongoing: ResponseTableStrings.ONGOING,
};

export const getTableLabel = (
  key: string,
  labelMapping: Record<string, string> = {}
) => {
  if (labelMapping && key in labelMapping) {
    return labelMapping[key];
  }
  return capitalizeCamelCaseFirstLetter(key);
};
